export const scrollToNearestVerticalPageEdge = () => {
  setTimeout(() => {
    const body = document.querySelector('body');
    const bodyHeight = body.scrollHeight;
    const halfBodyHeight = bodyHeight / 2;
    const currentScrollPosition = window.scrollY;

    if (currentScrollPosition > halfBodyHeight) {
      window.scrollTo({ top: bodyHeight, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
};
